import { Routes } from '@angular/router';
import { SurveysListComponent } from './surveys-list.component';
import { SurveysFormComponent } from './surveys-form.component';
import { SvsectionComponent } from './svsection/svsection.component';
import { SVSECTION_ROUTES } from './svsection/svsection.router';


export const SURVEYS_ROUTES: Routes = [
    { path: 'list', component: SurveysListComponent },
    { path: 'add', component: SurveysFormComponent },
    { path: 'edit/:id', component: SurveysFormComponent },
    { path: 'seccion', component: SvsectionComponent, children: SVSECTION_ROUTES },
    { path: '**', pathMatch: 'full', redirectTo: 'list'}
];